<template>
    <DataSet v-slot="{country, language, utm, campaignName, baseUrl}">
        <GTMPush
            v-slot="{push}"
            :country="country"
        >
            <UserFill
                v-slot="{user}"
                :baseURL="baseUrl"
            >
                <LeadCreate
                    v-slot="{create, loading}"
                    :country="country"
                    :language="language"
                    :baseUrl="baseUrl"
                    :utm="utm"
                    :campaignName="campaignName"
                    :utmSource="utmSource"
                    @submitted="formSubmitted"
                >
                    <Card class="FormContact">
                        <Transition
                            name="fade"
                            mode="out-in"
                        >
                            <B2BForm
                                v-if="!submitted"
                                :country="country"
                                :language="language"
                                :user="user"
                                :loading="loading"
                                @push="push"
                                @submit="create"
                            />
                            <Confirm
                                v-if="submitted"
                            />
                        </Transition>
                    </Card>
                </LeadCreate>
            </UserFill>
        </GTMPush>
    </DataSet>
</template>

<script lang="ts">

import Vue from 'vue';
import DataSet from '@/hoc/DataSet.vue';
import GTMPush from '@/hoc/GTMPush.vue';
import UserFill from '@/hoc/UserFill.vue';
import LeadCreate from '@/hoc/LeadCreate.vue';
import Component from 'vue-class-component';
import { Card } from '@free2move/vuejs-components'
import Transition from "@/components/Transition.vue";

import B2BForm from './B2BForm.vue';
import Confirm from './Confirm.vue';

@Component({
    components: {
        DataSet,
        GTMPush,
        Card,
        Transition,
        B2BForm,
        Confirm,
        UserFill,
        LeadCreate
    },
})
export default class Container extends Vue {
  public submitted = false;

  get utmSource() {
      const getCookie = (name: string) => {
          const cookieArr = document.cookie.split(';');
          for (let i = 0; i < cookieArr.length; i++) {
              const cookiePair = cookieArr[i].split('=');

              if (name === cookiePair[0].trim()) {
                  return decodeURIComponent(cookiePair[1]);
              }
          }
          return null;
      };

      return getCookie('utm_source');
  }

  formSubmitted() {
      this.submitted = true;
  }
}
</script>
